import classNames from "classnames";
import { useRouter } from "next/router";
import { BsFacebook, BsTwitter, BsWhatsapp } from "react-icons/bs";
import { shareUrls } from "../../data/share";
import { API } from "../../services/api/types";
import { Media } from "../Media";
import OddsAdvertisement from "../OddsAdvertisement";

const ArticleShare = ({
  isSponsored,
  campaign,
}: {
  isSponsored: boolean;
  campaign?: API.Campaign;
}) => {
  const router = useRouter();
  const currentUrl = `https://fotbolltransfers.com${router.asPath}`;

  const commonButtonClasses = [
    "text-white",
    "py-2",
    "px-3",
    "flex",
    "items-center",
    "gap-2",
  ];

  return (
    <div className={classNames("flex", "items-center", "gap-2")}>
      <a
        href={`${shareUrls.facebook}${encodeURIComponent(currentUrl)}`}
        target="_blank"
        rel="noreferrer"
        className={classNames(
          commonButtonClasses,
          "bg-[#3C5999]",
          "hover:bg-[#36508a]"
        )}
      >
        <Media greaterThanOrEqual="md">
          <BsFacebook size={23} />{" "}
        </Media>
        <Media lessThan="md">
          <BsFacebook size={20} />{" "}
        </Media>
        <Media greaterThanOrEqual="md">
          <span>Facebook</span>
        </Media>
      </a>
      <a
        href={`${shareUrls.twitter}${encodeURIComponent(currentUrl)}`}
        target="_blank"
        rel="noreferrer"
        className={classNames(
          commonButtonClasses,
          "bg-[#21A1F3]",
          "hover:bg-[#1c8dd6]"
        )}
      >
        <Media greaterThanOrEqual="md">
          <BsTwitter size={23} />{" "}
        </Media>
        <Media lessThan="md">
          <BsTwitter size={20} />{" "}
        </Media>
        <Media greaterThanOrEqual="md">
          <span>Twitter</span>
        </Media>
      </a>
      <a
        href={`${shareUrls.whatsapp}${encodeURIComponent(currentUrl)}`}
        target="_blank"
        rel="noreferrer"
        className={classNames(
          commonButtonClasses,
          "bg-[#4EC347]",
          "hover:bg-[#47b340]"
        )}
      >
        <Media greaterThanOrEqual="md">
          <BsWhatsapp size={23} />{" "}
        </Media>
        <Media lessThan="md">
          <BsWhatsapp size={20} />{" "}
        </Media>
        <Media greaterThanOrEqual="md">
          <span>WhatsApp</span>
        </Media>
      </a>
      {!isSponsored && campaign && (
        <OddsAdvertisement
          url={campaign.link}
          image={campaign.image}
          impression={campaign.impression}
          showDisclaimer
          text={
            <div className="mx-2">
              <div className="font-bold">Spela här</div>
              <div className="text-xs">Annons</div>
            </div>
          }
        />
      )}
    </div>
  );
};

export default ArticleShare;
